import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../index';

function resetPasswordSuccess(draft: Draft<IAuthData>) {
  draft.resetPassword.config.isLoading = false;
}

export default resetPasswordSuccess;
